import { ContentMedia } from '@/client/courses';
import { ContentMediaItem } from '@/ui/content-media';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import styled, { css } from 'styled-components';

const MediaColumn = styled(FlexContainer)<{ $isMobile: boolean }>`
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  width: auto;
  max-width: 280px;
  min-width: 0;

  ${({ $isMobile }) =>
    $isMobile &&
    css`
      flex: auto;
      width: 100%;
      margin: var(--default-padding) auto;
      margin-top: 0;
    `}
`;

type QuizQuestionMediaProps = {
  media: ContentMedia;
  alt?: string;
  isMobile?: boolean;
  onChange?: (media: ContentMedia) => void;
};

export const QuizQuestionMedia: React.FC<QuizQuestionMediaProps> = ({
  media,
  alt,
  isMobile = false,
  onChange,
}) => (
  <MediaColumn $isMobile={isMobile}>
    <ContentMediaItem media={media} alt={alt} onChange={onChange} />
  </MediaColumn>
);
